import React from "react";

function Loading() {
    return(
        <div className="loader">
           <img alt="Loading.." src="https://c.tenor.com/I6kN-6X7nhAAAAAj/loading-buffering.gif"></img>
        </div>
    )
}

export default Loading